// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const AffirmMessagingDemo: MarkdocTagRegistration = {
  tag: 'affirm-messaging-demo',
  component: 'AffirmMessagingDemo',
  attributes: {
    part: {
      type: String,
      default: 'product',
      description: 'Which part of the AffirmMessagingDemo to display.',
    },
  },
};
